import { useEffect, useRef } from 'react';

import { useModalControl } from 'Src/feature/modal/useModalControl';

type CheckPaymentModalOpenIntent = 'on-intent-change';
type CheckPaymentModalCloseIntent = 'on-backdrop-click' | 'on-cancel-click' | 'on-intent-change';

type UseCheckPaymentModalOptions = {
  onOpen: (intent: CheckPaymentModalOpenIntent) => void;
  onClose: (intent: CheckPaymentModalCloseIntent) => void;
  isOpen: boolean;
}

const useCheckPaymentModal = (options: UseCheckPaymentModalOptions) => {
  const { onClose, onOpen, isOpen } = options;
  const { open, close } = useModalControl<{ Close: CheckPaymentModalCloseIntent; Open: CheckPaymentModalOpenIntent }>({ onClose, onOpen });
  const ref_public = useRef({
    close,
    isOpen,
  });
  const ref_private = useRef({
    open,
  });
  ref_public.current.close = close;
  ref_private.current.open = open;
  ref_public.current.isOpen = isOpen;

  useEffect(() => {
    if (isOpen) ref_private.current.open('on-intent-change');
    else ref_public.current.close('on-intent-change');
  }, [isOpen]);

  return ref_public.current;
};

export { useCheckPaymentModal };
